export const colors = {
  color: "#703e9b",
  texture: "#00adcf",
  pattern: "#00c1ab",
  "line-silhouette": "#ae38b2",
};
